// extracted by mini-css-extract-plugin
export default {"default":"StatusIndicator_default__7qxge","success":"StatusIndicator_success__sLiLW","alert":"StatusIndicator_alert__16dC3","error":"StatusIndicator_error__2gNfD"};